import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "f6b2321a-ede1-45b3-8783-d6d442687e81",
    options: { imageUrl: `${config.ASSETS_URL}/04/10/task/task-1-item-1.svg` },
  },
  {
    id: "5fcff7b9-bae9-4f48-9232-5643f0a47b3a",
    options: { imageUrl: `${config.ASSETS_URL}/04/10/task/task-1-item-2.svg` },
  },
  {
    id: "563c23a2-21a7-4936-910c-e60f6ea7fd11",
    options: { imageUrl: `${config.ASSETS_URL}/04/10/task/task-1-item-3.svg` },
  },
  {
    id: "b261d0a3-8c0d-4047-882f-57fc23469806",
    options: { imageUrl: `${config.ASSETS_URL}/04/10/task/task-1-item-4.svg` },
  },
];

export const task: Task = {
  id: "d0581807-1572-42a6-91d6-5914136010bd",
  solutionType: "order",
  type: "orderImages",
  options: {
    orientation: "horizontal",
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "b261d0a3-8c0d-4047-882f-57fc23469806",
    "5fcff7b9-bae9-4f48-9232-5643f0a47b3a",
    "f6b2321a-ede1-45b3-8783-d6d442687e81",
    "563c23a2-21a7-4936-910c-e60f6ea7fd11",
  ],
};
